var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5657 1.56569C11.8781 1.25327 11.8781 0.746734 11.5657 0.434315C11.2533 0.121895 10.7467 0.121895 10.4343 0.434315L11.5657 1.56569ZM0.434315 10.4343C0.121895 10.7467 0.121895 11.2533 0.434315 11.5657C0.746734 11.8781 1.25327 11.8781 1.56569 11.5657L0.434315 10.4343ZM1.56569 0.434315C1.25327 0.121895 0.746734 0.121895 0.434315 0.434315C0.121895 0.746734 0.121895 1.25327 0.434315 1.56569L1.56569 0.434315ZM10.4343 11.5657C10.7467 11.8781 11.2533 11.8781 11.5657 11.5657C11.8781 11.2533 11.8781 10.7467 11.5657 10.4343L10.4343 11.5657ZM10.4343 0.434315L0.434315 10.4343L1.56569 11.5657L11.5657 1.56569L10.4343 0.434315ZM0.434315 1.56569L10.4343 11.5657L11.5657 10.4343L1.56569 0.434315L0.434315 1.56569Z",
    fill: "#0F143A",
    fillOpacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.2acd209d2c6c8b79c387eba21f3e7be2.svg";
export { ForwardRef as ReactComponent };